import Profesionales from "pages/LandingPages/Profesionales/profesionales";

export default function ProfesionalesPage() {
  return <Profesionales />;
}
